import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const SEOHead = () => {
  const { language } = useLanguage();
  
  const baseUrl = 'https://sarajevocitycenterapartments.com';
  const heroImage = 'https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/k3o4fnm2_image.png';
  
  const seoData = {
    en: {
      title: 'Sarajevo City Center Apartment near Presidency | 10/10 • Parking & Airport Transfer',
      description: 'Stay in central Sarajevo at Sarajevo City Center Apartment near Presidency. Rated 10/10 by Booking.com guests, with parking and complimentary airport pickup and drop-off.',
      url: baseUrl,
      locale: 'en_US',
    },
    hr: {
      title: 'Sarajevo City Center Apartment near Presidency | 10/10 • Parking i Aerodromski Transfer',
      description: 'Smještaj u centru Sarajeva - Sarajevo City Center Apartment near Presidency. Ocjena 10/10 na Booking.com, privatni parking i besplatan aerodromski transfer.',
      url: `${baseUrl}/hr`,
      locale: 'hr_HR',
    },
  };

  const currentLang = language || 'en';
  const data = seoData[currentLang] || seoData.en;

  useEffect(() => {
    // Schema.org structured data - defined inside useEffect to avoid dependency warning
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'LodgingBusiness',
      '@id': baseUrl,
      name: 'Sarajevo City Center Apartment near Presidency',
      description: currentLang === 'en' 
        ? 'Stay in the heart of Sarajevo, near the Presidency, with parking and complimentary transfer from and to Sarajevo International Airport.'
        : 'Smještaj u srcu Sarajeva, blizu Predsjedništva, s parkingom i besplatnim transferom od i do Međunarodnog aerodroma Sarajevo.',
      url: data.url,
      telephone: '+38763894069',
      email: 'janecek_i@hotmail.com',
      image: [
        heroImage,
        'https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/32akl3gp_20251214_190605.jpg',
        'https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/aeu9ce1q_20251214_184946.jpg',
        'https://customer-assets.emergentagent.com/job_eab806c6-a906-415c-9688-194d1cbd631e/artifacts/dg9dm5lg_20251214_185256.jpg',
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Koševo 21',
        addressLocality: 'Sarajevo',
        postalCode: '71000',
        addressCountry: 'BA',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 43.8563,
        longitude: 18.4131,
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '10.0',
        bestRating: '10',
        worstRating: '1',
        ratingCount: '29',
        reviewCount: '29',
      },
      amenityFeature: [
        { '@type': 'LocationFeatureSpecification', name: 'Free WiFi', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Air conditioning', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Heating', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Free private parking', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Smart TV', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Park view', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Airport pickup and drop-off', value: true },
        { '@type': 'LocationFeatureSpecification', name: 'Fully equipped kitchen', value: true },
      ],
      floorSize: {
        '@type': 'QuantitativeValue',
        value: 60,
        unitCode: 'MTK',
      },
      numberOfRooms: 2,
      occupancy: {
        '@type': 'QuantitativeValue',
        maxValue: 3,
        unitText: 'guests (2 adults + 1 child)',
      },
      checkinTime: '14:00',
      checkoutTime: '10:00',
      petsAllowed: false,
      smokingAllowed: false,
      priceRange: '$$',
      currenciesAccepted: 'EUR, BAM',
      paymentAccepted: 'Cash, Bank Transfer',
    };

    // Update document title
    document.title = data.title;
    
    // Update html lang attribute
    document.documentElement.lang = currentLang === 'hr' ? 'hr' : 'en';
    
    // Update or create meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', data.description);
    }
    
    // Update canonical link
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', data.url);
    }
    
    // Update OG tags
    const ogTags = {
      'og:title': data.title,
      'og:description': data.description,
      'og:url': data.url,
      'og:locale': data.locale,
    };
    
    Object.entries(ogTags).forEach(([property, content]) => {
      const tag = document.querySelector(`meta[property="${property}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      }
    });
    
    // Update Twitter tags
    const twitterTags = {
      'twitter:title': data.title,
      'twitter:description': data.description,
      'twitter:url': data.url,
    };
    
    Object.entries(twitterTags).forEach(([name, content]) => {
      const tag = document.querySelector(`meta[name="${name}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      }
    });

    // Update JSON-LD schema
    const schemaScript = document.querySelector('script[type="application/ld+json"]');
    if (schemaScript) {
      schemaScript.textContent = JSON.stringify(schemaData);
    }
  }, [currentLang, data, baseUrl, heroImage]);

  return null;
};

export default SEOHead;
